import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="swipable"
export default class extends Controller {
  static targets = [ "prev", "next", "area" ]

  connect() {

    var startX;
    var endX;

    var contr = this;
    this.areaTarget.addEventListener('touchstart', function(event) {
      startX = event.touches[0].clientX;
    });

    this.areaTarget.addEventListener('touchend', function(event) {
        endX = event.changedTouches[0].clientX;

        if (Math.abs(startX - endX) > 50) { // Минимальное расстояние для свайпа
            if (startX < endX) {
              if(contr.hasPrevTarget) contr.prevTarget.click();
            } else {
              if(contr.hasNextTarget) contr.nextTarget.click();
            }
        }
    });
  }
}
